import { ENDPOINT } from '../../constants/server/api';
import { fetchApiData } from '../../utils/apiUtils';

export const createBranchTableZoneAndTable = (businessSlug, requestBody) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'post',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}/zone-and-table`,
      params: {
        business_slug: businessSlug
      },
      data: requestBody,
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getBranchTableZonePagination = (businessSlug, params) => async dispatch => {
  const { per_page, ...otherParams } = params;

  const data = await fetchApiData({
    method: 'get',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}/pagination/list`,
    params: {
      ...otherParams,
      perPage: per_page || params.perPage
    },
    dispatch
  });
  return data;
};

export const getBranchTableZoneById = (businessSlug, id) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'get',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}/${id}`,
      params: {
        business_slug: businessSlug
      },
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getBranchTableZoneExcel = (businessSlug, params) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'post',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}/excel`,
      params: {
        business_slug: businessSlug,
        ...params
      },
      responseType: 'blob',
      dispatch
    });
    if (data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'branch_table_zones.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error(error);
  }
};

export const deleteBranchTableZone = (businessSlug, id) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'delete',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}/${id}`,
      params: {
        business_slug: businessSlug
      },
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateBranchTableZone = (businessSlug, id, requestBody) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'put',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}/${id}`,
      params: {
        business_slug: businessSlug
      },
      data: requestBody,
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const createBranchTableZone = (businessSlug, requestBody) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'post',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}`,
      params: {
        business_slug: businessSlug
      },
      data: requestBody,
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllBranchTableZones = (businessSlug, branchId) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE_ZONE}`,
    params: {
      business_slug: businessSlug,
      branchId: branchId
    },
    dispatch
  });
  return data;
};

export const deleteBranchTable = (businessSlug, id) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'delete',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE}/${id}`,
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateBranchTable = (businessSlug, id, requestBody) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'put',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE}/${id}`,
      data: requestBody,
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAllBranchTables = (businessSlug, zoneId) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE}`,
    params: {
      zoneId: zoneId
    },
    dispatch
  });
  return data;
};

export const createBranchTable = (businessSlug, requestBody) => async dispatch => {
  try {
    const data = await fetchApiData({
      method: 'post',
      endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TABLE}`,
      data: requestBody,
      dispatch
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
